import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/authStore'
import { jwtDecode } from 'jwt-decode'
import { toast } from 'sonner'

export default function GoogleCallback() {
  const navigate = useNavigate()
  const setAccessToken = useAuthStore((s) => s.auth.setAccessToken)
  const setUser = useAuthStore((s) => s.auth.setUser)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    if (token) {
      setAccessToken(token)
      localStorage.setItem('token', token)
      // JWT'den kullanıcıyı decode et ve store'a yaz
      try {
        const decoded = jwtDecode(token) as Record<string, unknown>;
        setUser({
          id: String(decoded.userId || ''),
          name: String(decoded.username || ''),
          email: String(decoded.eposta || decoded.email || ''),
          role: Array.isArray(decoded.role) ? String(decoded.role[0] || 'user') : String(decoded.role || 'user'),
        })
        toast.success(`Hoşgeldin ${typeof decoded.username === 'string' ? decoded.username : (typeof decoded.eposta === 'string' ? decoded.eposta : 'kullanıcı')}!`, {
          description: 'Başarıyla giriş yaptınız.',
        })
        setTimeout(() => {
          navigate({ to: '/' })
        }, 2500)
      } catch (_e: unknown) {
        // decode hatası olursa kullanıcıyı set etme
      }
    }
  }, [setAccessToken, setUser, navigate])

  return (
    <div className='flex justify-center items-center min-h-screen text-lg'>
      Google ile giriş yapılıyor...
    </div>
  )
} 